import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingBarService } from '@ngx-loading-bar/core';

import Swal from 'sweetalert2';

import {
  HeaderService,
  ServiceOrderService
} from '../../../shared';

@Component({
  selector: 'app-service-order-return',
  templateUrl: './service-order-return.component.html',
  styleUrls: ['./service-order-return.component.scss']
})
export class ServiceOrderReturnComponent implements OnInit {
  title = "RETORNAR ORDEM DE SERVIÇO";
  subtitle = "Utilize o campo abaixo para descrever o motivo do retorno";
  urlBack = "/panel/service-order/list";

  serviceOrder = new FormGroup({
    idFsRequisicao: new FormControl(''),
    dsObservacao: new FormControl('', Validators.required)
  });

  id;

  constructor(
    private headerService: HeaderService,
    private activatedRoute: ActivatedRoute,
    private loadingBarService: LoadingBarService,
    private serviceOrderService: ServiceOrderService,
    private router: Router
  ) {
    if (this.activatedRoute.snapshot.params.id) {
      this.id = this.activatedRoute.snapshot.params.id;

      this.serviceOrder.patchValue({
        idFsRequisicao: this.id
      });
    }
  }

  ngOnInit() {
    this.headerService.changeTitle('Retornar ordem de serviço');

    this.headerService.changeSubtitle('');

    this.headerService.changeDatePicker(false);
  }

  returnServiceOrder() {
    this.loadingBarService.start();

    this.serviceOrderService.returnServiceOrder(this.serviceOrder.value).subscribe((response) => {
      this.loadingBarService.complete();

      this.serviceOrder.reset();

      Swal({
        type: "success",
        title: "Ordem de serviço",
        text: "Ordem de serviço retornado para loja",
        confirmButtonText: "Ok, obrigado!",
        confirmButtonClass: "sweet-button",
        buttonsStyling: false
      }).then((result) => {
        this.router.navigate([this.urlBack]);
      });
    });
  }

}
